"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeasonsList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all seasons.
 *
 * ### Filter options
 *
 * - `finished` - filter by seasons which have start and end date,
 * - `active` - filter by seasons which have start date but did not yet finish,
 * - `inactive` - filter by seasons which do not have start date,
 * - `unfinished` - filter by seasons which do not have end date,
 *
 * ### Sort options
 *
 * - `startDate` - sorts by season starting date,
 * - `endDate` - sorts by season ending date.
 *
 * ## Usage
 *
 * ```ts
 * const seasonsAll: Season[] = await sdk.getSeasonsList();
 * const seasonsFinished: Season[] = await sdk.getSeasonsList({ finished: true });
 * const seasonsInactive: Season[] = await sdk.getSeasonsList({ inactive: true });
 * ```
 *
 * @param params.filter - Filter to apply to returned races list.
 * @param params.filter.inactive - Get only seasons which are yet to start.
 * @param params.filter.active - Get only currently active seasons.
 * @param params.filter.finished - Get only past seasons.
 * @param params.filter.unfinished - Get only seasons which are not finished.
 * @param params.sort - Fields to sort season list by.
 * @param params.limit - How many seasons will get returned.
 */
const getSeasonsList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/seasons/list`;
    const seasonResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = seasonResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getSeasonsList = getSeasonsList;
